const OnboardHandler = (product, event, data) => {
    const { metaData = {}, url = '', amount = 0 } = data,
        { userId } = metaData;

    const finalData = {
        userId, product, urlPath: url
    };

    switch (event) {
        case 'PageView':
            break;
        case 'LeadFormSubmit':
            break;
        case 'Step1PageView':
            break;
        case 'Step1PlanA':
            break;
        case 'Step1PlanB':
            break;
        case 'Step1PlanC':
            break;
        case 'Step1Payment':
            finalData = { ...finalData, payment: amount, paymentInitiated: true }
            break;
        case 'Step2PageView':
            break;
        case 'Step2Save&Continue':
            break;
        case 'Step3PageView':
            break;
        case 'Step3Submit':
            break;
        case 'Step4PageView':
            break;
        case 'Step4Submit':
            break;
        case 'Step5PageView':
            break;
        case 'InternalVerificationEnabled':
            break;
        case 'InternalVerificationDisabled':
            break;
    }

    return finalData;

}

module.exports = { OnboardHandler }